export default "__VITE_ASSET__DqhZ_XJa__"